import React, { useState } from 'react';
import { Section } from '../../../../fc-components/main/components';
import MarketoForm from '../../../../components/MarketoForm/MarketoForm';
import PropTypes from 'prop-types';
import NewsletterOption from './NewsletterOption';

const MarketoNewsletterForm = ({ handleSubmission }) => {
  const [checkedCompass, setCheckCompass] = useState(true);
  const [checkedCodesign, setCheckCodesign] = useState(true);
  const [checkedImpact, setCheckImpact] = useState(true);
  const [checkedPlugged, setCheckPlugged] = useState(true);
  const [checkedModernCeo, setCheckedModernCeo] = useState(true);
  const [checkedTopTen, setCheckedTopTen] = useState(true);

  const handleCheckCompass = () => {
    setCheckCompass(prev => !prev);
    const marketoInput = document.getElementsByName(
      'optInFCCompassNewsletter'
    )[0];
    if (!marketoInput) return;

    if (checkedCompass) {
      marketoInput.checked = false;
    } else {
      marketoInput.checked = true;
    }
  };

  const handleCheckCodesign = () => {
    setCheckCodesign(prev => !prev);
    const marketoInput = document.getElementsByName(
      'optInFCCoDesignNewsletter'
    )[0];
    if (!marketoInput) return;

    if (checkedCodesign) {
      marketoInput.checked = false;
    } else {
      marketoInput.checked = true;
    }
  };

  const handleCheckImpact = () => {
    setCheckImpact(prev => !prev);
    const marketoInput = document.getElementsByName(
      'optInFCImpactNewsletter'
    )[0];
    if (!marketoInput) return;

    if (checkedImpact) {
      marketoInput.checked = false;
    } else {
      marketoInput.checked = true;
    }
  };

  const handleCheckPlugged = () => {
    setCheckPlugged(prev => !prev);
    const marketoInput = document.getElementsByName(
      'optInFCPluggedInNewsletter'
    )[0];
    if (!marketoInput.length === 0) return;

    if (checkedPlugged) {
      marketoInput.checked = false;
    } else {
      marketoInput.checked = true;
    }
  };

  const handleCheckModernCeo = () => {
    setCheckedModernCeo(prev => !prev);
    const marketoInput = document.getElementsByName(
      'optInFCModernCEONewsletter'
    )[0];
    if (!marketoInput) return;

    if (checkedModernCeo) {
      marketoInput.checked = false;
    } else {
      marketoInput.checked = true;
    }
  };

  const handleCheckTopTen = () => {
    setCheckedTopTen(prev => !prev);
    const marketoInput = document.getElementsByName(
      'optInFCTop10Newsletter'
    )[0];
    if (!marketoInput) return;

    if (checkedTopTen) {
      marketoInput.checked = false;
    } else {
      marketoInput.checked = true;
    }
  };

  return (
    <Section bgColor="#F4F4F4" noPadding>
      <div className="newsletters__page__marketo">
        <div className="newsletters__page__marketo__form__container">
          <div className="options">
            <NewsletterOption
              onChange={handleCheckCompass}
              isChecked={checkedCompass}
              imgUrl="https://assets.fastcompany.com/image/upload/v1670274719/fc-newsletter-logo.svg"
              imgAlt="Compass Newsletter"
              description="Fast Company’s trending stories delivered to you daily"
              frequency="Daily"
            />
            <NewsletterOption
              onChange={handleCheckCodesign}
              isChecked={checkedCodesign}
              imgUrl="https://assets.fastcompany.com/image/upload/v1670274604/fc-newsletter-logo_CoDesign.svg"
              imgAlt="CoDesign Newsletter"
              description="The latest innovations in design brought to you every weekday"
              frequency="Weekdays"
            />
            <NewsletterOption
              onChange={handleCheckImpact}
              isChecked={checkedImpact}
              imgUrl="https://assets.fastcompany.com/image/upload/v1670274672/fc-newsletter-logo_impact.svg"
              imgAlt="Impact Newsletter"
              description="A weekly look at the people and ideas making an impact in society and business"
              frequency="Weekly"
            />
            <NewsletterOption
              onChange={handleCheckPlugged}
              isChecked={checkedPlugged}
              imgUrl="https://assets.fastcompany.com/image/upload/v1670274702/fc-newsletter-logo_pluggedin.svg"
              imgAlt="Plugged In Newsletter"
              description="Tech insights, news, and trends from global technology editor Harry McCracken"
              frequency="Monthly"
            />
            <NewsletterOption
              className="top-ten"
              onChange={handleCheckTopTen}
              isChecked={checkedTopTen}
              imgUrl="https://assets.fastcompany.com/image/upload/v1680283662/newsletters/fcTopTen.svg"
              imgAlt="FastCompany Top10 Newsletter logo"
              description="Fast Company’s Top 10 trending stories of the week, delivered to you each Sunday"
              frequency="Weekly"
            />
            <NewsletterOption
              className="modern-ceo"
              onChange={handleCheckModernCeo}
              isChecked={checkedModernCeo}
              imgUrl="https://assets.fastcompany.com/image/upload/v1680285557/newsletters/modernCEOBlack.svg"
              imgAlt="Modern CEO Newsletter"
              description="A refreshed look at leadership from CEO and chief content officer Stephanie Mehta"
              frequency="Weekly"
            />
          </div>
          <MarketoForm assetId={1211} onSubmitHandler={handleSubmission} />
        </div>
      </div>
    </Section>
  );
};

export default MarketoNewsletterForm;

MarketoNewsletterForm.propTypes = {
  handleSubmission: PropTypes.func.isRequired
};
